import React, { useState, useEffect } from 'react';
import { Card } from '../../components/ui/Card';
import {
    ClipboardDocumentListIcon,
    CheckCircleIcon,
    ArrowPathIcon,
    ChartBarIcon,
    UsersIcon,
    ClockIcon
} from '@heroicons/react/24/outline';
import { surveyApiService } from '../../api/surveyApi';

const SurveyDashboard = () => {
    const [stats, setStats] = useState({
        totalSurveys: 0,
        activeSurveys: 0,
        totalSubmissions: 0,
        completionRate: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await surveyApiService.getSurveys();
                const surveys = Array.isArray(response) ? response : (response?.results || []);
                setStats({
                    totalSurveys: surveys.length,
                    activeSurveys: surveys.filter(s => s.is_active).length,
                    totalSubmissions: 0,
                    completionRate: 0
                });
            } catch (error) {
                console.error('Error fetching survey stats:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, []);

    const statCards = [
        { label: 'Total Surveys', value: stats.totalSurveys, icon: ClipboardDocumentListIcon, color: 'text-blue-600', bg: 'bg-blue-50 dark:bg-blue-900/20' },
        { label: 'Active Surveys', value: stats.activeSurveys, icon: CheckCircleIcon, color: 'text-green-600', bg: 'bg-green-50 dark:bg-green-900/20' },
        { label: 'Total Submissions', value: stats.totalSubmissions, icon: UsersIcon, color: 'text-purple-600', bg: 'bg-purple-50 dark:bg-purple-900/20' },
        { label: 'Avg. Completion', value: '5.2m', icon: ClockIcon, color: 'text-amber-600', bg: 'bg-amber-50 dark:bg-amber-900/20' },
    ];

    return (
        <div className="p-6 space-y-6">
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Survey Dashboard</h1>
                    <p className="text-sm text-gray-500">Track and manage your professional surveys</p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {statCards.map((card, index) => (
                    <Card key={index} className="p-4 border-none shadow-sm dark:bg-gray-800">
                        <div className="flex items-center space-x-4">
                            <div className={`${card.bg} p-3 rounded-xl`}>
                                <card.icon className={`w-6 h-6 ${card.color}`} />
                            </div>
                            <div>
                                <p className="text-sm font-medium text-gray-500 dark:text-gray-400">{card.label}</p>
                                <p className="text-2xl font-bold text-gray-900 dark:text-white">{card.value}</p>
                            </div>
                        </div>
                    </Card>
                ))}
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <Card className="p-6 dark:bg-gray-800 border-none shadow-sm">
                    <h2 className="text-lg font-bold mb-4 flex items-center">
                        <ChartBarIcon className="w-5 h-5 mr-2 text-blue-500" />
                        Recent Activity
                    </h2>
                    <div className="space-y-4">
                        <p className="text-sm text-gray-500 italic">Activity tracking coming soon...</p>
                    </div>
                </Card>

                <Card className="p-6 dark:bg-gray-800 border-none shadow-sm">
                    <h2 className="text-lg font-bold mb-4 flex items-center">
                        <ArrowPathIcon className="w-5 h-5 mr-2 text-green-500" />
                        Active Surveys
                    </h2>
                    <div className="space-y-4">
                        <p className="text-sm text-gray-500 italic">Quick access to active surveys...</p>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default SurveyDashboard;
